import {createAction} from 'web-app/util/redux/famly-app-helpers';
import {type PUBLIC_FUNDING_TYPE} from 'web-app/react/entities/plans/constants';

const domain = 'MODALS/CHOOSE_PUBLIC_FUNDING';

export const {action: show} = createAction(
    `${domain}/SHOW`,
    (fundingMethod: PUBLIC_FUNDING_TYPE, defaultMaxFundedMinutesPerDay: number | null, institutionId: string) => ({
        fundingMethod,
        defaultMaxFundedMinutesPerDay,
        institutionId,
    }),
);

export const {action: save} = createAction(`${domain}/SAVE`, publicFundingSettings => ({publicFundingSettings}));

export const {action: hide} = createAction(`${domain}/HIDE`, () => ({}));

export const {action: manuallyClose} = createAction(`${domain}/MANUALLY_CLOSE`, () => ({}));

export const {action: changeFundingMethod} = createAction(
    `${domain}/CHANGE_FUNDING_METHOD`,
    (newFundingMethod: PUBLIC_FUNDING_TYPE) => ({newFundingMethod}),
);
